// extracted by mini-css-extract-plugin
module.exports = {"heroSection":"styles-module--heroSection--OpMqk"};